import { graphql } from "react-relay"
import { useMutationWithErrorDialog } from "@/hooks/useMutationWithErrorDialog"
import { useDeleteConsultationReportMutation as useDeleteConsultationReportMutationType } from "@/modules/patients/detail/consultation-report/services/__generated__/useDeleteConsultationReportMutation.graphql"

const deleteConsultationReportMutation = graphql`
  mutation useDeleteConsultationReportMutation($input: Ch_deleteConsultationReportInput!) {
    ch_deleteConsultationReport(input: $input) {
      ch_ConsultationReport {
        id @deleteRecord
      }
    }
  }
`

const useDeleteConsultationReportMutation = () => {
  return useMutationWithErrorDialog<useDeleteConsultationReportMutationType>(deleteConsultationReportMutation)
}

export { useDeleteConsultationReportMutation }
